export default function ApplyListHeader() {
  return (
    <div className="flex items-center gap-lg rounded bg-gray_darken px-xl py-xs text-heading-3xs font-bold text-main">
      <p className="w-[179px] shrink-0">応募日 / 応募者</p>
      <p className="w-[348px] shrink-0">選考企業</p>
      <p className="shrink-0 whitespace-nowrap">選考ステータス / メモ</p>
      <p className="flex-1" />
      <p className="w-[116px] shrink-0 text-right">送受信日</p>
    </div>
  );
}
